
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    max: {
      type: Number,
      default: 100,
    },
    min: {
      type: Number,
      default: 0,
    },
    modelValue: {
      type: Number,
      default: 0,
    },
  },
  setup(props, { emit }) {
    const onChange = (evt: Event) => {
      const target = evt.target as HTMLInputElement

      emit('update:modelValue', target.value)
    }

    return {
      props,
      onChange,
    }
  },
})
